import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const logo = "https://storage.googleapis.com/connct-cba18.firebasestorage.app/frontend-assets/Conncct-logo.png";
const dm1 = "https://storage.googleapis.com/connct-cba18.firebasestorage.app/frontend-assets/dem1.png";


export default function Dm3() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: ''
    });
    const [error, setError] = useState('');

    const handleInputChange = (field: string, value: string) => {
        // Restrict numbers for first and last name
        if ((field === 'firstName' || field === 'lastName') && /\d/.test(value)) {
            return;
        }
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const toggleLanguage = () => {
        const newLang = i18n.language === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(newLang);
    };

    const handleNext = () => {
        if (!formData.firstName || !formData.lastName || !formData.email) {
            setError(t('demo.fillAllFields'));
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setError('Please enter a valid email address');
            return;
        }
        setError(''); // Clear error if validation passes
        // Navigate to demo2
        navigate('/dm4', { state: formData });
    };

    return (
        <div className="min-h-screen bg-white">
            {/* Header */}
            <header className="flex items-center justify-between px-8 py-4 border-b border-gray-200">
                <div className="flex items-center gap-2">
                    <img
                        src={logo}
                        alt="Connct Logo"
                        className="h-8 object-contain"
                        onClick={() => navigate("/dashboard")}
                    />
                </div>

            </header>

            {/* Main Content */}
            <div className="flex flex-col md:flex-row min-h-[calc(100vh-73px)]">

                <div className="w-full md:w-1/2 flex items-center justify-center bg-[#E0F7FA] p-8 md:p-12 overflow-hidden">
                    <img src={dm1} alt="" className="max-w-[400px] w-full object-contain" />
                </div>

                {/* Right Side - Form */}
                <div className="w-full md:w-1/2 flex items-center justify-center p-8 lg:p-12">
                    <div className="w-full max-w-md">
                        <h1 className="text-[32px] md:text-[40px] font-bold text-black mb-4 leading-tight">
                            {t('demo.title1')}
                        </h1>

                        {/* Tags */}
                        <div className="flex flex-wrap gap-3 mb-8 mt-4">
                            <span className="px-4 py-2 bg-[#E1F5FE] text-[#0288D1] rounded-lg text-sm font-semibold">
                                {t('demo.tag1')}
                            </span>
                            <span className="px-4 py-2 bg-[#E1F5FE] text-[#0288D1] rounded-lg text-sm font-semibold">
                                {t('demo.tag2')}
                            </span>
                            <span className="px-4 py-2 bg-[#E1F5FE] text-[#0288D1] rounded-lg text-sm font-semibold">
                                {t('demo.tag3')}
                            </span>
                        </div>

                        {/* Form Fields */}
                        <div className="space-y-4">
                            <div className="grid grid-cols-2 gap-4">
                                <input
                                    type="text"
                                    placeholder={t('demo.firstName')}
                                    value={formData.firstName}
                                    onChange={(e) => handleInputChange('firstName', e.target.value)}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                />
                                <input
                                    type="text"
                                    placeholder={t('demo.lastName')}
                                    value={formData.lastName}
                                    onChange={(e) => handleInputChange('lastName', e.target.value)}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            <div className="w-full">
                                <input
                                    type="email"
                                    placeholder={t('demo.email')}
                                    value={formData.email}
                                    onChange={(e) => {
                                        handleInputChange('email', e.target.value);
                                        if (error) setError('');
                                    }}
                                    className={`w-full px-4 py-3 border ${error ? 'border-red-500' : 'border-gray-300'} rounded-lg text-sm bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500`}
                                />
                                {error && <p className="text-red-500 text-xs mt-1 ml-1">{error}</p>}
                            </div>
                        </div>

                        {/* Terms */}
                        <p className="text-[11px] text-gray-500 mt-4">
                            {t('demo.terms')}{' '}
                            <a href="#" className="text-blue-600 hover:underline">
                                {t('demo.termsLink')}
                            </a>
                        </p>

                        {/* Next Button */}
                        <div className="mt-8">
                            <button
                                onClick={handleNext}
                                className="px-8 py-3 bg-[#1976D2] text-white rounded-lg font-medium hover:bg-blue-700 transition flex items-center gap-2"
                            >
                                {t('demo.next')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
